/**
 * Application Constants
 * Centralized location for all hardcoded values used throughout the application
 */

export const CONTACT = {
  WHATSAPP_NUMBER: "593994060018",
  WHATSAPP_NUMBER_ALT: "593987398610",
  LOCATION: {
    ADDRESS: "Aurora Plaza, Unidad Nacional y Juan Lavalle, Riobamba, Ecuador",
    COORDINATES: {
      LAT: -1.669365,
      LNG: -78.655296,
    },
  },
} as const;

export const BRANDING = {
  APP_NAME: "Aurora Plaza",
  TAGLINE: "Tu Centro de Innovación en Riobamba",
  BROCHURE_URL: "https://www.canva.com/design/DAGitsBLJ4s/sVyHSm9VoQQyYCDF3Cw-VA/view?embed",
} as const;

export const NAVIGATION = {
  SECTIONS: {
    HOME: "inicio",
    FLOORS_OVERVIEW: "explora-plaza-aurora",
    SPACES: "espacios", 
    STORES: "tiendas",
    CONTACT: "contacto",
  },
} as const;

const WHATSAPP_GENERIC_MESSAGE = "¡Hola! Me gustaría saber: ";

export const MESSAGES = {
  WHATSAPP: {
    CAFE_INFO: WHATSAPP_GENERIC_MESSAGE,
    SCHEDULE_VISIT: WHATSAPP_GENERIC_MESSAGE,
    GENERAL_INFO: WHATSAPP_GENERIC_MESSAGE,
    REQUEST_VISIT: WHATSAPP_GENERIC_MESSAGE,
  },
} as const;

export const IMAGES = {
  PLAZA: [
    "/Plaza/1.webp",
    "/Plaza/2.webp", 
    "/Plaza/3.webp",
    "/Plaza/4.webp",
    "/Plaza/5.webp",
    "/Plaza/6.webp",
  ],
  GELTOKIA: [
    "/Plaza/Geltokia/1.webp",
    "/Plaza/Geltokia/2.webp",
    "/Plaza/Geltokia/3.webp",
    "/Plaza/Geltokia/4.webp",
    "/Plaza/Geltokia/5.webp",
    "/Plaza/Geltokia/6.webp",
  ],
  BANBAN: [
    "/Plaza/BanBan/1.webp",
    "/Plaza/BanBan/2.webp",
    "/Plaza/BanBan/3.webp",
    "/Plaza/BanBan/4.webp",
    "/Plaza/BanBan/5.webp",
    "/Plaza/BanBan/6.webp",
  ],
  RELUX_TECH: [
    "/Plaza/ReLuX_Tech/1.webp",
    "/Plaza/ReLuX_Tech/2.webp",
    "/Plaza/ReLuX_Tech/3.webp",
    "/Plaza/ReLuX_Tech/4.webp",
    "/Plaza/ReLuX_Tech/5.webp",
    "/Plaza/ReLuX_Tech/6.webp",
  ],
  ZEN_GARDEN: [
    "/Plaza/Zen_Garden/1.webp",
    "/Plaza/Zen_Garden/2.webp",
    "/Plaza/Zen_Garden/3.webp",
    "/Plaza/Zen_Garden/4.webp",
  ],
  PUBLIC_PLAZA: [
    "/Plaza/Public_Plaza/1.webp",
    "/Plaza/Public_Plaza/2.webp",
    "/Plaza/Public_Plaza/3.webp",
    "/Plaza/Public_Plaza/4.webp",
    "/Plaza/Public_Plaza/5.webp",
  ],
  LED_SCREEN: [
    "/Plaza/LED_Screen/1.webp",
    "/Plaza/LED_Screen/2.webp",
    "/Plaza/LED_Screen/3.webp",
  ],
  PUBLIC_TERRACE: [
    "/Plaza/Public_Terrace/1.webp",
    "/Plaza/Public_Terrace/2.webp",
    "/Plaza/Public_Terrace/3.webp",
    "/Plaza/Public_Terrace/4.webp",
  ],
  PERGOLA: [
    "/Plaza/Pergola/1.webp",
    "/Plaza/Pergola/2.webp",
    "/Plaza/Pergola/3.webp",
  ],
  HATARI_ARCADE: [
    "/Plaza/Hatari_Arcade/1.webp",
    "/Plaza/Hatari_Arcade/2.webp",
    "/Plaza/Hatari_Arcade/3.webp",
    "/Plaza/Hatari_Arcade/4.webp",
    "/Plaza/Hatari_Arcade/5.webp",
  ],
  AIRBNB_ROOM_1: [
    "/Plaza/AirBnB_Rooms/Room1/1.webp",
    "/Plaza/AirBnB_Rooms/Room1/2.webp",
    "/Plaza/AirBnB_Rooms/Room1/3.webp",
    "/Plaza/AirBnB_Rooms/Room1/4.webp",
    "/Plaza/AirBnB_Rooms/Room1/5.webp",
    "/Plaza/AirBnB_Rooms/Room1/6.webp",
  ],
  AIRBNB_ROOM_2: [
    "/Plaza/AirBnB_Rooms/Room2/1.webp",
    "/Plaza/AirBnB_Rooms/Room2/2.webp",
    "/Plaza/AirBnB_Rooms/Room2/3.webp",
    "/Plaza/AirBnB_Rooms/Room2/4.webp",
    "/Plaza/AirBnB_Rooms/Room2/5.webp",
    "/Plaza/AirBnB_Rooms/Room2/6.webp",
  ],
  AIRBNB_ROOM_3: [
    "/Plaza/AirBnB_Rooms/Room3/1.webp",
    "/Plaza/AirBnB_Rooms/Room3/2.webp",
    "/Plaza/AirBnB_Rooms/Room3/3.webp",
    "/Plaza/AirBnB_Rooms/Room3/4.webp",
    "/Plaza/AirBnB_Rooms/Room3/5.webp",
    "/Plaza/AirBnB_Rooms/Room3/6.webp",
  ],
  AIRBNB_ROOMS: [
    "/Plaza/AirBnB_Rooms/1.webp",
    "/Plaza/AirBnB_Rooms/2.webp",
    "/Plaza/AirBnB_Rooms/3.webp",
    "/Plaza/AirBnB_Rooms/4.webp",
    "/Plaza/AirBnB_Rooms/5.webp",
    "/Plaza/AirBnB_Rooms/6.webp",
  ],
  PEAK_CONFERENCE_ROOM: [
    "/Plaza/Peak_Conference_Room/1.webp",
    "/Plaza/Peak_Conference_Room/2.webp",
    "/Plaza/Peak_Conference_Room/3.webp",
    "/Plaza/Peak_Conference_Room/4.webp",
  ],
  URKU_LABS: [
    "/Plaza/Urku_Labs/1.webp",
    "/Plaza/Urku_Labs/2.webp",
    "/Plaza/Urku_Labs/3.webp",
    "/Plaza/Urku_Labs/4.webp",
    "/Plaza/Urku_Labs/5.webp",
    "/Plaza/Urku_Labs/6.webp",
  ],
  SOLAR_PANELS: [
    "/Plaza/Solar_Panels/1.webp",
    "/Plaza/Solar_Panels/2.webp",
    "/Plaza/Solar_Panels/3.webp",
    "/Plaza/Solar_Panels/4.webp",
  ],
  ISLAND_GROUND_FLOOR_5SQM: [
    "/Plaza/island_ground_5sqm_1.webp",
    "/Plaza/island_ground_5sqm_2.webp",
  ],
  ISLAND_SECOND_FLOOR_10SQM: [
    "/Plaza/island_second_10sqm_1.webp",
    "/Plaza/island_second_10sqm_2.webp",
  ],
} as const;
